export default __webpack_public_path__ + "static/media/pop_logo.84bef3d8.png";